import { render, staticRenderFns } from "./TemplateDefault.vue?vue&type=template&id=1c64e01c"
import script from "./TemplateDefault.vue?vue&type=script&lang=js"
export * from "./TemplateDefault.vue?vue&type=script&lang=js"
import style0 from "./TemplateDefault.vue?vue&type=style&index=0&id=1c64e01c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports